import React from "react";
import { LetterOfAuthorization, Header, Image, Subheader, LetterContent, InstructionList,InstructionSubList, ContributionSubList, FontMediumText, OwnerAuthority, VanguardRepresentative, SignGurantee, FormInput, AuthorizedOffice, Mail, Email, Fax, Guildelines, AboutVanguard, Print, AuthorizationText, FontBoldText, LetterWrapper } from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
import moment from "moment";
let assetMF = [];

export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter();
    }

    componentWillUnmount = () => {
        localStorage["assetMF"] = "";
    }

    renderPrintData = () => {
        return (
            <LetterOfAuthorization>
            <Image justifyContent = "flex-start" marginBottom="10px">
                <img src={logo} alt="vanguard"></img>
            </Image>
            <Header>Standing letter of authorization</Header>
            <Subheader>Contribution of Vanguard mutual fund shares held at The Vanguard Group, Inc. (Vanguard) and/or Vanguard
                Brokerage Services (VBS)</Subheader>
            <LetterContent>
                Use this letter to give continuing authority to Vanguard and/or VBS to accept instructions from representatives of Vanguard Charitable to
                transfer shares from your accounts to Vanguard Charitable.
                <ul>
                    <li>Please consult your attorney if there is anything about this form you do not understand.</li>
                    <li>Please complete a separate form for each of your separately registered accounts at Vanguard and/or VBS for which you wish to keep <AuthorizationText>Standing letter of
                        authorization</AuthorizationText> on file.</li>
                    <li>All registered owners must sign this <AuthorizationText>Standing letter of
                        authorization</AuthorizationText> and have their signature(s) notarized.Do not sign this form until you
                        are in the presence of a notary public.</li>
                    <li>Vanguard and/or VBS reserves the right to refuse to honor any transfer instruction it may receive from Vanguard Charitable without
                        prior notice. And, Vanguard and/or VBS may, but is/are not required to, require you to verify and approve any particular transfer
                        request it receives from Vanguard Charitable pursuant to this authorization, as well as request that you periodically verify that this
                        authorization is valid.</li>
                    <li>Vanguard reserves the right to require a new form at any time.</li>
                    <li>For the most current cost basis information for contributions of Vanguard mutual fund shares, contact Vanguard Charitable.</li>
                    <li>Vanguard representatives are available at 800-284-7245</li>
                    <li>Vanguard Charitable representatives are available at 888-383-4483</li>
                </ul>
            </LetterContent>
            <InstructionList>
                <li>
                    Authorize to accept instructions
                    <div>
                    I/We authorize Vanguard and/or VBS to accept instructions from an authorized representative of Vanguard Charitable to transfer assets
                    I/we hold in the Vanguard and/or VBS account listed below to a Vanguard Charitable account. I/We understand that Iwe can have only
                    one Standing <i>letter of authorization</i> per registration on file at Vanguard and/or VBS at a time, and that each authorization I/we complete
                    and submit to Vanguard and/or VBS for a registration will revoke any previously completed authorization for that registration. This
                    authorization will continue in full force and effect until it is revoked by either account owner in writing, or until it is automatically revoke
                    by the death or legal incapacity of either account owner. Any revocation will not be effective until notice of the revocation, death or legal
                    incapacitation is received by Vanguard and/or VBS at one of the following addresses, and Vanguard and/or VBS has/have had a reasonal
                    amount of time to act upon such notice. By U.S. Mail: Vanguard, P.O. Box 1110, Valley Forge, PA 19482-1110. By registered, certified
                    or overnight mail: Vanguard, 455 Devon Park Drive, Wayne, PA 19087-1815.
                    </div>
                </li>
                <li>
                    Vanguard Charitable account information
                    <div>Account number: { assetMF[0].logAcNum }</div>
                    <div>Account name: { assetMF[0].logAcName }</div>
                </li>
                <li>
                    Vanguard and/or VBS registration covered by this authorization
                    <div>Account registration: { assetMF[0].donorName }</div>
                    <div>Vanguard and/or VBS account number: { assetMF[0].accountNumber }</div>
                    <div>This authorization covers the account number(s) listed above, as well as any successor account numbers assigned as a result of a share
                        conversion, fund merger, or similar action</div>
                </li>
                <li>
                Signatures: This section must be signed by all registered owners/trustees/officers of the assets to be donated.
                    <div className="mt-05">I understand that neither Vanguard, nor VBS, nor any of their affiliates will be under any duty whatsoever to question any transfer
                        instructions received from a representative of Vanguard Charitable or to question the suitability of any transfer instruction received. Nor
                        will Vanguard or VBS be under any duty to review or monitor the terms of any agreement between Vanguard Charitable and me. I confirm
                        that if I am required to execute any other document(s) in order to give Vanguard Charitable the authority described in this Standing letter
                        of authorization, I have done so.
                    </div>
                    <div className="mt-05">
                        I understand and agree that it is my responsibility to review and monitor account activity and to promptly notify Vanguard and/or VBS of
                        any unauthorized activity.I agree to indemnify and hold Vanguard, VBS, Vanguard Marketing Corporation, their affiliates and each of th
                        investment company members of The Vanguard Group, Inc., and their respective officers, employees, and agents harmless from acting on
                        instructions, whether oral, written, or electronic, reasonably believed by Vanguard and/or VBS to have originated from an authorized
                        representative of Vanguard Charitable and who Vanguard and/or VBS believes is acting pursuant to this authorization.
                    </div>
                    <div className="mt-05">
                        I agree that Vanguard and/or VBS will not be liable for processing any transaction initiated before Vanguard and/or VBS has had a
                        reasonable amount of time to act upon notice of revocation of this authorization or notice of the death or incapacitation of an account
                        owner.
                    </div>
                    <div className="mt-05">
                        I/We agree that VBS will not be liable for processing any transaction requested by Vanguard Charitable and initiated before VBS has had
                        reasonable amount of time to act upon notice of revocation of this authorization or notice of the death or incapacit
                        ation of an account
                        owner.
                    </div>
                    <div className="mt-05">
                        I have read this authorization in its entirety, or had it read and explained to me, and I understand and agree to its contents. By signing
                        below, I certify that I have full authority to give this authorization.
                    </div>
                    <div className="mt-05">
                        For trustees: By signing below, I/we certify that I/we have the power and authority under the trust agreement and applicable law to give
                        this authorization. 
                    </div>
                    <div className="mt-05">
                        On the date noted below, before the undersigned, a notary public, personally appeared the individual(s) named below, satisfactorily prove
                        to be the person whose name is signed to the within instrument, and acknowledged that (s)he executed the same for the purpose therein
                        contained.
                    </div>
                    <div className="mt-05">
                        <i>
                            This form requires an acknowledgement of signature, which can be obtained from a notary. The notar zation must be dated within 30 da
                            of receipt of this document by Vanguard Charitable.
                        </i>
                    </div>
                    <div className="mt-05 mb-05"><FontBoldText>Signature(s) </FontBoldText>Do not sign until you are in the presence of the person acknowledging your signature</div>
                    <OwnerAuthority>
                        <div>Owner A</div>
                        <div>Owner's Name: {assetMF[0].donorName}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    <OwnerAuthority>
                        <div>Owner B</div>
                        <div>Owner's Name: {assetMF[0].donorName}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    <div className="mt-05">Acknowledgement of signature - REQUIRED</div>
                    <div className="mt-05">In witness whereof, I hereunto set my hand and official seal.</div>
                    <FormInput className="mt-05">
                        <label>Signature of notary public:</label>
                        <input type="text"></input>
                    </FormInput>
                    <FormInput>
                        <label>Commission expiration date</label>
                        <input type="text"></input>
                    </FormInput>
                    <AuthorizedOffice>
                        <div>
                            Notary seal <AuthorizationText>if state requires a seal</AuthorizationText>
                        </div>
                        <div></div> 
                    </AuthorizedOffice>
                </li>
                <li>Return information
                    <div>
                    Return this completed form by mail to: <FontBoldText>Vanguard Charitable, P.O. Box 9509, Warwick, RI 02889-9509</FontBoldText>
                    </div>
                </li>
            </InstructionList>
            <Guildelines>
                If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                For more information, view our <a href={assetMF[0].envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                <span>Policies and guidelines</span></a> booklet.
            </Guildelines>
            <AboutVanguard>
                Vanguard Charitable was founded by The Vanguard Group, Inc. as an independent, nonprofit, public
                charity in 1997. Although Vanguard provides certain investment management and administrative services
                to Vanguard Charitable pursuant to a service agreement, Vanguard Charitable is not a program or activity
                of Vanguard. A majority of Vanguard Charitable's Trustees are independent of Vanguard.
            </AboutVanguard>
            <AboutVanguard>© {moment().format('YYYY')} Vanguard Charitable Endowment Program. All rights reserved.</AboutVanguard>
        </LetterOfAuthorization>  
        )
    }

    render() {
        assetMF = [];
        assetMF = JSON.parse(localStorage["assetMFSLOA"]);
        return (
                     <LetterWrapper> 
                     <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                            {this.renderPrintData()}
                        </PrintComponents>
                     {this.renderPrintData()}</LetterWrapper>
            );
    }
}

export default ViewContribution;